import React from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
export default function ResetPasswordModal({
  handleClose,
  showResetPassword,
  forgotPassword,
  loader2,
  username,
  handleInputChange,
  setUsername,
  errorResetPassword,
  successMessage,
  handleModalHide,
}) {
  return (
    <Modal
      show={showResetPassword}
      size="lg"
      onHide={() => handleModalHide()}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Mot de passe oublié</Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          forgotPassword();
        }}
      >
        <Modal.Body>
          {loader2 ? (
            <div className="text-center">
              <Spinner
                animation={loader2 ? "border" : false}
                role="status"
              ></Spinner>
            </div>
          ) : (
            <div className="row">
              <div className="col-md-12">
                <Form.Group className="mb-3" controlId={`reset-password-email`}>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Email"
                    pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                    autoComplete={`reset-password-email`}
                    title="ex : utilisateur@gmail.com"
                    required
                    value={username}
                    name="email"
                    onChange={(e) => {
                      handleInputChange(e);
                      setUsername(e.target.value);
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Text className="text-danger">
                    {errorResetPassword}
                  </Form.Text>
                  <Form.Text className="text-success">
                    {successMessage}
                  </Form.Text>
                </Form.Group>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="is-bottom-right">
          <Button
            variant="secondary"
            onClick={() => {
              handleClose();
            }}
          >
            Annuler
          </Button>
          <Button
            variant="success"
            type="submit"
            disabled={username.length === 0 ? true : false}
          >
            Valider
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
